import React, { useEffect, useState, useContext } from 'react';
import { CreateObject } from '../../../services/DataService';
import { AsButton } from '@adserve/adserve-react-components';
import DayPartWeights from './DayPartWeightings/DayPartWeights';
import DayWeights from './DayPartWeightings/DayWeights';
import AsSelectWithPlaceholder from '../../generic/AsSelectWithPlaceholder';
import AsTextarea from '../../generic/AsTextArea';
import { labelStyle, rationalDescriptionStyle } from '../CampaignBrief/CampaignBriefStyles';
import { AirtimePlanningContext } from '../../../contexts/AirtimePlanningContext';

const DayPartWeightings = ({
    campaign,
    changeMadeParent,
    campaignShapes,
    readOnly,
    onSpotTypeDistributionApprovalClick,
    activeRequest = {},
    onRationaleChange,
    changeSpotDistribution,
    spotTypeDistributionWorkflowId
}) => {
    const { showInvalidatePlanMessage } = useContext(AirtimePlanningContext);

    const [localDayWeights, setLocalDayWeights] = useState([]);
    const [localDayPartWeights, setLocalDayPartWeights] = useState([]);
    const [canReset, setCanReset] = useState(false);
    const [mounted, setMounted] = useState(false);

    const changeMade = () => {
        if (!campaign.changed) {
            changeMadeParent('applicableDayParts', localDayPartWeights);
        }
        checkReset(localDayPartWeights, localDayWeights);
    };

    const checkReset = (daypartWeights, dayWeights) => {
        const ldpw = daypartWeights?.filter((a) => a.percentage !== a.basePercentage);

        const ldw = dayWeights?.filter((a) => a.percentage !== a.basePercentage);
        const cnReset = ldw?.length > 0 || ldpw?.length > 0;
        if (canReset !== cnReset) setCanReset(cnReset);
    };

    useEffect(() => {
        if (campaign) {
            if (
                campaign.applicableDayParts?.length &&
                (campaign.campaignStations?.length || campaign.burstStations?.length)
            ) {
                const req = {
                    stations: campaign.campaignStations?.length
                        ? campaign.campaignStations.map((a) => a.id)
                        : campaign.burstStations.map((a) => a.id),
                    dayParts: campaign.applicableDayParts
                };

                const currentStations = campaign.campaignStations?.length
                    ? JSON.stringify(campaign.campaignStations.map((a, b) => a.id))
                    : JSON.stringify(campaign.burstStations.map((a, b) => a.id));
                if (!campaign.hasOwnProperty('distributionStationsChanged')) {
                    campaign.distributionStationsChanged = true;
                }
                if (
                    campaign.distributionStationsChanged ||
                    (!campaign.distributionStationsChanged && campaign.dayWeights === null)
                ) {
                    campaign.distributionStationsChanged = false;
                    CreateObject('rajarcaches/ImpactDistributions', req).then((data) => {
                        campaign.dayWeights = [
                            {
                                id: 1,
                                name: window.translate('Monday'),
                                weight: 100
                            },
                            {
                                id: 2,
                                name: window.translate('Tuesday'),
                                weight: 100
                            },
                            {
                                id: 3,
                                name: window.translate('Wednesday'),
                                weight: 100
                            },
                            {
                                id: 4,
                                name: window.translate('Thursday'),
                                weight: 100
                            },
                            {
                                id: 5,
                                name: window.translate('Friday'),
                                weight: 100
                            },
                            {
                                id: 6,
                                name: window.translate('Saturday'),
                                weight: 100
                            },
                            {
                                id: 0,
                                name: window.translate('Sunday'),
                                weight: 100
                            }
                        ];
                        let dayTotal = 0;

                        for (let i = 0; i < 7; i++) {
                            campaign.dayWeights[i].percentage = data.days[i];
                            dayTotal += data.days[i];
                        }
                        for (let i = 0; i < 7; i++) {
                            campaign.dayWeights[i].percentage = (campaign.dayWeights[i].percentage / dayTotal) * 100;
                            campaign.dayWeights[i].basePercentage = campaign.dayWeights[i].percentage;
                        }
                        let dayPartTotal = 0;
                        for (let i = 0; i < campaign.applicableDayParts.length; i++) {
                            dayPartTotal += data.dayParts[i].impacts;
                        }
                        for (let i = 0; i < campaign.applicableDayParts.length; i++) {
                            campaign.applicableDayParts[i].percentage = (data.dayParts[i].impacts / dayPartTotal) * 100;
                            campaign.applicableDayParts[i].basePercentage = campaign.applicableDayParts[i].percentage;
                            campaign.applicableDayParts[i].weight = 100;
                        }
                        setLocalDayWeights([...campaign.dayWeights]);
                        setLocalDayPartWeights([...campaign.applicableDayParts]);
                        checkReset(campaign?.applicableDayParts, campaign?.dayWeights);
                    });
                } else {
                    if (campaign?.dayWeights) setLocalDayWeights([...campaign.dayWeights]);
                    if (campaign?.applicableDayParts) setLocalDayPartWeights([...campaign.applicableDayParts]);
                    checkReset(campaign?.applicableDayParts, campaign?.dayWeights);
                }
                campaign.lastStations = currentStations;
            } else {
                console.log('No stations currently selected');
            }
        }
    }, [campaign.applicableDayParts, campaign.campaignStations, campaign.burstStations]);

    useEffect(() => {
        checkReset(localDayPartWeights, localDayWeights);
    }, [localDayWeights, localDayPartWeights]);

    //Seems like redundant code, check for displaying weights is done on render (can see below)
    //Creating a new campaign/burst default values are set, only if displaying sliders can user edit values for weighting
    //meaning the below is not needed.
    // useEffect(() => {
    //     console.log('DayPartWeightsHello2');
    //     const isPanelShowing =
    //         (changeSpotDistribution && onRationaleChange === undefined) ||
    //         (changeSpotDistribution && onRationaleChange !== undefined && spotTypeDistributionWorkflowId === null) ||
    //         (activeRequest &&
    //             activeRequest?.id &&
    //             activeRequest?.state?.name === 'Approved' &&
    //             activeRequest?.isComplete);

    //     if (mounted && !isPanelShowing) {
    //         console.log('mounted && !isPanelShowing so clearing weights');
    //         clearWeights();
    //     }
    // }, [mounted, changeSpotDistribution, activeRequest]);

    useEffect(() => {
        setMounted(true);
        return () => {
            setMounted(false);
        };
    }, []);

    const clearWeights = () => {
        localDayPartWeights.map((a, b) => {
            a.percentage = a.basePercentage;
            a.weight = 100;
            a.changed = false;
            return true;
        });
        setLocalDayPartWeights([...localDayPartWeights]);
        localDayWeights.map((a, b) => {
            a.percentage = a.basePercentage;
            a.weight = 100;
            a.changed = false;
            return true;
        });
        setLocalDayWeights([...localDayWeights]);
        setCanReset(false);
    };

    const handleCampaignShapeChange = (event) => {
        let { value } = event.target;
        if (value <= 0) {
            value = window.emptyGuid;
        }

        if (typeof changeMadeParent === 'function') {
            changeMadeParent(event.target.name, value);
        }
    };

    const handleChange = (event) => {
        const { name, value } = event.target;
        if (onRationaleChange) {
            onRationaleChange(name, value);
        }
    };

    const handleRequestApprovalClick = () => {
        if (onSpotTypeDistributionApprovalClick) {
            onSpotTypeDistributionApprovalClick();
        }
    };

    const handleResetClick = () => {
        clearWeights();
        showInvalidatePlanMessage(null, false);
    };

    return (
        <div key={'dayanddaypartweightspanel'}>
            <div
                key='part1'
                style={{
                    display: 'flex',
                    color: '#414141',
                    flexDirection: 'column',
                    WebkitUserSelect: 'none' /* Safari */,
                    WebkitTouchCallout: 'none' /* iOS Safari */,
                    KhtmlUserSelect: 'none' /* Konqueror HTML */,
                    MsUserSelect: 'none' /* Internet Explorer/Edge */,
                    MozUserSelect: 'none' /* Old versions of Firefox */,
                    UserSelect: 'none' /* Non-prefixed version */
                }}
            >
                {changeSpotDistribution && onRationaleChange !== undefined && spotTypeDistributionWorkflowId && (
                    <>
                        <div
                            key='part3'
                            style={{
                                fontSize: 15,
                                fontWeight: 500,
                                marginBottom: 18,
                                marginTop: 26
                            }}
                        >
                            {activeRequest && activeRequest.id
                                ? window.translate('Spot Type Distribution')
                                : window.translate('Enable Spot Type Distribution')}
                        </div>

                        <div
                            style={{
                                height:
                                    activeRequest && activeRequest.id && activeRequest?.state?.name === 'Approved'
                                        ? 150
                                        : 225,
                                width: '100%',
                                marginRight: 17,
                                fill: '#ffffff',
                                border: '1px solid #D7D7D7',
                                borderRadius: 8
                            }}
                        >
                            <div style={{ marginTop: 11, marginLeft: 16 }}>
                                <span
                                    style={{
                                        width: 225,
                                        height: 19,
                                        fontFamily: 'Roboto',
                                        fontSize: 16,
                                        color: '#000000',
                                        textDecoration: ' none solid rgb(0, 0, 0)',
                                        fontWeight: 600
                                    }}
                                >{`${window.translate('Approval Status')}: ${
                                    activeRequest?.state?.name === 'Approved'
                                        ? activeRequest?.state?.name
                                        : activeRequest?.state?.name === 'Denied'
                                        ? window.translate('Rejected ')
                                        : activeRequest && activeRequest.id && !activeRequest.isComplete
                                        ? window.translate('Awaiting Approval')
                                        : window.translate('Not requested')
                                }`}</span>
                            </div>
                            <div style={{ width: '100%', marginLeft: 16, marginTop: 10 }}>
                                <AsTextarea
                                    id='campaign-rationale'
                                    name='spotTypeRationale'
                                    title={window.translate('Rationale *')}
                                    labelStyle={labelStyle}
                                    inputStyle={{ ...rationalDescriptionStyle, width: '96%' }}
                                    value={campaign?.spotTypeRationale}
                                    onChange={handleChange}
                                    disabled={
                                        readOnly || (activeRequest?.id && activeRequest?.state?.name === 'Approved')
                                    }
                                />
                            </div>
                            {activeRequest && activeRequest.id && activeRequest?.state?.name === 'Approved' ? (
                                <></>
                            ) : (
                                <AsButton
                                    style={{
                                        fontSize: 15,
                                        fontWeight: 'bold',
                                        marginTop: 14,
                                        marginLeft: 16
                                    }}
                                    handleClick={handleRequestApprovalClick}
                                    disabled={
                                        readOnly ||
                                        (activeRequest?.id && activeRequest?.state?.name === 'Approved') ||
                                        !campaign.spotTypeRationale
                                    }
                                >
                                    {activeRequest && activeRequest.id && !activeRequest.isComplete
                                        ? window.translate('Awaiting Approval')
                                        : window.translate('Request Approval')}
                                </AsButton>
                            )}
                        </div>
                    </>
                )}

                {/* below displays sliders when:
                (campaign burst) &&
                (campaign with no workflow) &&
                (campaign with workflow that has been approved & complete) */}
                {((changeSpotDistribution && onRationaleChange === undefined) ||
                    (changeSpotDistribution &&
                        onRationaleChange !== undefined &&
                        spotTypeDistributionWorkflowId === null) ||
                    (activeRequest &&
                        activeRequest?.id &&
                        activeRequest?.state?.name === 'Approved' &&
                        activeRequest?.isComplete)) && (
                    <>
                        <div style={{ width: '19%', alignSelf: 'flex-end', marginTop: 10 }}>
                            <AsSelectWithPlaceholder
                                id='campaign-shape'
                                name='campaignShapeId'
                                title={window.translate('Campaign shape')}
                                values={campaignShapes}
                                value={campaign?.campaignShapeId || 0}
                                onChange={handleCampaignShapeChange}
                                disabled={readOnly}
                                disabledStyle={{ color: '#919191' }}
                            />
                        </div>
                        <div key={'dayweightscontrol'} style={{ display: 'flex' }}>
                            <DayWeights
                                dayWeights={localDayWeights}
                                changeMade={changeMade}
                                readOnly={
                                    readOnly ||
                                    (campaign?.campaignShapeId !== window.emptyGuid &&
                                        campaign?.campaignShapeId !== null)
                                }
                            ></DayWeights>
                            <div
                                style={{
                                    width: 1,
                                    borderRight: '1px solid #d7d7d7',
                                    boxSizing: 'border-box',
                                    marginLeft: '5.7%',
                                    marginRight: '5%',
                                    marginTop: 60
                                }}
                            ></div>
                            <DayPartWeights
                                key={'daypartweightscontrol'}
                                dayPartWeights={localDayPartWeights}
                                changeMade={changeMade}
                                readOnly={
                                    readOnly ||
                                    (campaign?.campaignShapeId !== window.emptyGuid &&
                                        campaign?.campaignShapeId !== null)
                                }
                            ></DayPartWeights>
                        </div>
                        <div>
                            <div
                                style={{
                                    display: 'flex',
                                    justifyContent: 'flex-end'
                                }}
                            >
                                <AsButton
                                    style={{
                                        height: 40,
                                        width: 100,
                                        marginTop: 5
                                    }}
                                    handleClick={handleResetClick}
                                    disabled={readOnly || !canReset}
                                >
                                    {window.translate('Reset')}
                                </AsButton>
                            </div>
                        </div>
                    </>
                )}
            </div>
        </div>
    );
};
export default DayPartWeightings;
